var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"raised":"","color":"grey darken-2"}},[_c('v-card-text',[_c('pie-chart',{attrs:{"data":_vm.chartData,"valuesTitle":"Percent","title":_vm.dataVariable.name}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }